import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-6 offset-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Push通知の許可", -1)
const _hoisted_5 = {
  class: "form-check form-switch",
  style: {"display":"inline-block","transform":"scale(1.5)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "push-notification-toggle",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isPushEnabled) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePushToggle && _ctx.handlePushToggle(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.isPushEnabled]
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}